var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-box" },
    [
      _c("el-row", [
        _vm._v(" 可分配金额剩余 "),
        _c("span", { staticStyle: { color: "seagreen" } }, [
          _vm._v(_vm._s(_vm.availableAmount)),
        ]),
        _vm._v(" 元 "),
      ]),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 20, offset: 1 } },
            [
              _c("vxe-toolbar", {
                scopedSlots: _vm._u([
                  {
                    key: "buttons",
                    fn: function () {
                      return [
                        _c(
                          "vxe-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.addTable()
                              },
                            },
                          },
                          [_vm._v("添加人员")]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c(
                "vxe-table",
                { attrs: { align: _vm.allAlign, data: _vm.tableData } },
                [
                  _c("vxe-table-column", {
                    attrs: { field: "userCode", title: "人员编码" },
                  }),
                  _c("vxe-table-column", {
                    attrs: { field: "userName", title: "人员名称" },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "amount500Above",
                      title: "500(含)以上(元)",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("el-input", {
                              attrs: {
                                type: "number",
                                placeholder: "请输入500(含)以上(元)",
                                precision: "2",
                                min: "0",
                              },
                              on: { change: _vm.reSetMoney },
                              model: {
                                value: row.amount500Above,
                                callback: function ($$v) {
                                  _vm.$set(row, "amount500Above", $$v)
                                },
                                expression: "row.amount500Above",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "amountOtherProduct",
                      title: "其他产品(元)",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("el-input", {
                              attrs: {
                                type: "number",
                                placeholder: "请输入其他产品(元)",
                                precision: "2",
                                min: "0",
                              },
                              on: { change: _vm.reSetMoney },
                              model: {
                                value: row.amountOtherProduct,
                                callback: function ($$v) {
                                  _vm.$set(row, "amountOtherProduct", $$v)
                                },
                                expression: "row.amountOtherProduct",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "amountCustomProduct",
                      title: "定制产品(元)",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("el-input", {
                              attrs: {
                                type: "number",
                                placeholder: "请输入定制产品(元)",
                                precision: "2",
                                min: "0",
                              },
                              on: { change: _vm.reSetMoney },
                              model: {
                                value: row.amountCustomProduct,
                                callback: function ($$v) {
                                  _vm.$set(row, "amountCustomProduct", $$v)
                                },
                                expression: "row.amountCustomProduct",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-table-column", {
                    attrs: { field: "totalAmount", title: "合计(元)" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [_c("span", [_vm._v(_vm._s(row.totalAmount))])]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-table-column", {
                    attrs: { label: "操作", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "danger" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelete(row)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("SelectConfig", {
        ref: "selectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }